import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useMediaQuery } from '@material-ui/core';

import { Sidebar } from './components';
import Topbar from './components/Topbar';
import { AppName } from '../../constants';
import packageInfo from '../../../package.json';
import Chat from './components/Chat';
import { getDynamicConfigValue } from "../../dynamicConfig";

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: 56,
    height: '100%',
    [theme.breakpoints.up('sm')]: {
      paddingTop: 64
    }
  },
  shiftContent: {
    paddingLeft: 240
  },
  content: {
    height: '100%'
  }
}));
var open;
const Main = props => {
  const { children } = props;
  const { brandingInfo } = props;
  const classes = useStyles();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'), {
    defaultMatches: true
  });
  const [showFraudEngines, setShowFraudEngines] = useState(
    localStorage.getItem('Fraud') !== null
      ? localStorage.getItem('Fraud') === 'true'
        ? true
        : false
      : false
  );
  const [showAMLEngines, setShowAMLEngines] = useState(
    localStorage.getItem('Aml') !== null
      ? localStorage.getItem('Aml') === 'true'
        ? true
        : false
      : true
  );
  const [openSidebar, setOpenSidebar] = useState(
    localStorage.getItem('Sidebar') !== null
      ? localStorage.getItem('Sidebar') === 'true'
        ? true
        : false
      : true
  );
  const handleSidebar = () => {
    setOpenSidebar(!openSidebar);
    localStorage.setItem('Sidebar', !openSidebar);
  };

  return (
    <div
      className={clsx({
        [classes.root]: true,
        [classes.shiftContent]: openSidebar
      })}>
      <Topbar
        open={openSidebar}
        onSidebarOpen={handleSidebar}
        showFraudEngines={showFraudEngines}
        setShowFraudEngines={setShowFraudEngines}
        showAMLEngines={showAMLEngines}
        setShowAMLEngines={setShowAMLEngines}
        brandingInfo={brandingInfo}
      />
      <Sidebar
        open={openSidebar}
        showFraudEngines={showFraudEngines}
        showAMLEngines={showAMLEngines}
        variant={'persistent'}
      />
      <main className={classes.content}>{children}</main>
      { getDynamicConfigValue('REACT_APP_GEN_AI_VISIBLE') == "true" &&
        <Chat
        showFraudEngines={showFraudEngines}
        showAMLEngines={showAMLEngines}
        />
      }
      <div style={{ textAlign: "center", color: '#BBB', 
            fontSize: '14px', fontWeight: 400, margin: '20px'}}>
        {AppName.Display} {packageInfo.version} - powered by Neo4j
      </div>
    </div>
  );
};

Main.propTypes = {
  children: PropTypes.node
};

export default Main;
